export default __webpack_public_path__ + "static/media/matcap_02.446da5cd.jpg";